// extracted by mini-css-extract-plugin
export default {"container":"Marketplace_container__-Ajfk","mainSection":"Marketplace_mainSection__ga4SX"};